//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { groupByStartTime, formatDayLabel } from './scheduleResultGrouping.js';
import { formatTime, formatDate } from './scheduleTimeUtils.js';

export default {
  name: 'SchedulePrintView',

  props: {
    sessions: { type: Array, default: () => [] },
    groupingMode: { type: String, default: 'time-grouped' }, // 'time-grouped' | 'flat'
    scope: { type: String, default: 'all' }, // 'all' | 'current'
  },

  computed: {
    eventTitle() { return (this.$root.config && this.$root.config.eventTitle) || ''; },
    eventDates() {
      // Compose a human label from the raw ISO strings plumbed through
      // $root.config (eventStartDate / eventEndDate), mirroring the
      // approach used by SessionPrintView.
      const cfg = this.$root.config || {};
      const start = formatDate(cfg.eventStartDate || '');
      const end = formatDate(cfg.eventEndDate || '');
      if (start && end && start !== end) return `${start} – ${end}`;
      return start || end || '';
    },
    scopeLabel() {
      return this.scope === 'all' ? 'Complete Agenda' : 'Search Results';
    },
    selectedDayValue() {
      return this.$store.getters.selectedDayValue || null;
    },
    activeFilterChips() {
      const ALLOWED_GROUPS = ['session_format', 'session_topics', 'session_credit_type'];
      const filters = this.$store.getters.filters || [];
      return filters
        .filter(g => ALLOWED_GROUPS.includes(g.id))
        .flatMap(g => (g.filters || []).filter(f => f.selected).map(f => f.value));
    },
    hasActiveFilters() {
      return !!(this.selectedDayValue || this.activeFilterChips.length);
    },
    dayLabel() {
      return this.selectedDayValue ? formatDayLabel(this.selectedDayValue) : '';
    },

    days() {
      // group by date string, preserving order
      const byDay = new Map();
      this.sessions.forEach(s => {
        const date = (s.meta && s.meta.startDate) || '';
        const label = formatDate(date) || 'TBD';
        if (!byDay.has(label)) byDay.set(label, []);
        byDay.get(label).push(s);
      });
      return Array.from(byDay.entries()).map(([label, list]) => ({
        label,
        groups: groupByStartTime(list, {
          sortOption: { fieldName: 'startTime' },
          searchTerm: '',
        }),
      }));
    },
  },

  methods: {
    formatTime,
    formatDate,
    creditFor(session) {
      const v = session.meta && session.meta.sessionCreditType;
      if (!v || v === 'Not for Credit') return '';
      return v;
    },
    isPreregRequired(session) {
      const value = session && session.meta && session.meta.preregRequired;
      if (value === undefined || value === null || value === false) return false;
      if (value === 'false' || value === 0 || value === '0') return false;
      return Boolean(value);
    },
  },
};
